
<section class="top-section">
    <div class="headline">
        <div class="intro">
            <h3 class="title">Typical case studies show 10%-17% cost savings during the first year alone.<br> Ask us how much we can save you</h3>
            <p class="text"> - Lisa McCourry, WorldERP CEO</p>
        </div>
    </div>
    <div class="title-about-us">
        <h1 class="main-title">
            About Us
        </h1>
        <p class="main-sub-title">
            The Experts in Hyperconvergence and Hyperautomation
        </p>
    </div>

</section>
